import {useQuery} from "@tanstack/react-query";
import {PcsSearchParamType} from "../interface";
import {readDeliveryList} from "../../../../../api/purchase/PcsApi";
import {pcsListMapInit} from "../state";

type Props = {
    param: PcsSearchParamType;
    enabled?: boolean
};

export const useReadDeliveryList = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readDeliveryList", param],
        queryFn: async () => await readDeliveryList(param),
        select: (res) => res?.data.result ?? pcsListMapInit,
        enabled: !!enabled
    });

    return {data};
};
